import React from 'react'
import { CarouselCard, Carousel } from '../../types'
import style from './card.module.scss'
import { DownIcon, DeleteIcon } from '../../../../icons'
import { UploadImage } from './UploadImage'
import { Actions } from './Actions'

type Props = CarouselCard & {
	isOpen: boolean
	index: number
	mode: "view" | "edit" | "create"
	toggleCard: (index: number, currVisibility?: Record<string, boolean>) => void
	updateCard: (key: keyof CarouselCard, value: any, index: number) => void
	removeCard: (index: number) => void
	card: CarouselCard
	initialValue?: Carousel["contentValue"] & { id: string };
	error: Record<"cards" | "actions", Record<string, string> | undefined>
	clearError: (index: number, name: "actions" | "cards", key: string) => void
	removeErrorForIndex: (index: number) => void
}

export function Card(props: Props) {
	const { isOpen, mode, card, updateCard, index, clearError } = props
	const error = props.error.cards ?? {}
	return (
		<div className={style.card}>
			<Header {...props} />
			{isOpen && (
				<div className={style.content}>
					<div className={style.inputWrapper}>
						<label>Title</label>
						<input disabled={mode === "view"} autoFocus placeholder="Enter title" value={card.title} onChange={e => {
						  clearError(index, "cards", "title")
							const title = e.currentTarget.value
							updateCard("title", title, index)
						}} />
						<span className={style.error}>{error.title}</span>
					</div>
					<div className={style.inputWrapper}>
						<label>Subtitle</label>
						<input disabled={mode === "view"} placeholder="Enter subtitle" value={card.subtitle} onChange={e => {
						  clearError(index, "cards", "subtitle")
							const subtitle = e.currentTarget.value
							updateCard("subtitle", subtitle, index)
						}} />
						<span className={style.error}>{error.subtitle}</span>
					</div>
					<div className={style.desc}>
						<div className={style.descHeader}>
							<label htmlFor="desc">Description</label>
							<span data-empty={card.description.trim() === ""}>{card.description.trim().length} / 250</span>
						</div>
						<textarea disabled={mode === "view"} id="desc" value={card.description} placeholder="Enter description" onChange={(e) => {
						  clearError(index, "cards", "description")
							const description = e.currentTarget.value
							if (description.length <= 250) {
								updateCard("description", description, index)
							}
						}} />
						<span className={style.error}>{error.description}</span>
					</div>

					<UploadImage error={error.url} clearError={() => clearError(index, "cards", "url")} mode={mode} onChange={(url: string) => updateCard("url", url, index)} url={card.url} />

					<Actions clearError={clearError} error={props.error.actions} mode={mode} card={card} updateCard={updateCard} index={index} />
				</div>
			)}
		</div>
	)
}

function Header(props: Props) {
	const { title, isOpen, toggleCard, removeCard, index, mode, removeErrorForIndex } = props
	return (
		<div role="button" onClick={() => toggleCard(index)} data-open={isOpen} className={style.header}>
			<p>{title || "Untitled"}</p>
			<div>
				<div className={style.down}>
					<DownIcon stroke="#393939" width="10" height="10" />
				</div>
				{mode !== "view" && (
					<button onClick={(e) => {
						e.stopPropagation()
						removeCard(index)
						removeErrorForIndex(index)
					}}>
						<DeleteIcon width="13" height="13" stroke="#393939" />
					</button>
				)}
			</div>
		</div>
	)
}
